import moment from 'moment'
import Barcode from 'react-barcode'

//To Do:
//Change reference to a link and add code to display it

const mimes = [{ type: 'application/pdf', ext: 'pdf' }, { type: 'application/vnd.ms-powerpoint', ext: 'ppt' }, { type: 'application/msword', ext: 'doc' }, { type: 'text/css', ext: 'css' }, { type: 'text/csv', ext: 'csv' }, { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', ext: 'docx' }, { type: 'image/gif ', ext: 'gif' }, { type: 'text/html', ext: 'html' }, { type: 'image/jpeg', ext: 'jpg' }, { type: 'application/vnd.ms-excel', ext: 'xls' }]

export function Integers(ints) {
    return ints.toString().replace(/,/g, ', ')
}

export function Strings(s) {
    return s.toString().replace(/,/g, '\n')
}

export function Code(code) {
    return code.toString().replace(/,/g, ', ') //code ? code.toString().replace(/,/g, ', ') : ''
}

export function Identifier(id) {
    return id.map(i => {
        let type = i.type ? CodeableConcept(i.type) : 'Internal'
        return `${type}: ${i.value || "???"}`
    }).toString().replace(/,/g, '\n')
}

export function SingleIdentifier(i) {
    let type = i.type ? CodeableConcept(i.type) : 'Internal'
    return `${type}: ${i.value || "???"}`
}

export function Contained(contained) {
    let text = ''
    contained.forEach(c => {
        if (c.code && c.code.coding && c.code.coding[0]) {
            c.code.coding.forEach(cd => {
                if (Coding(cd)) text += (text ? `; ${Coding(cd)}` : Coding(cd))
            })
        }
    })
    return text
}

export function Coding(coding) {
    return coding.display || coding.code || ''
}

export function CodeableConcept(codeableConcept) {
    let text = codeableConcept.text || ''
    if (text === '' && codeableConcept.coding && codeableConcept.coding[0]) {
        codeableConcept.coding.forEach(c => {
            if (Coding(c)) text += (text ? `; ${Coding(c)}` : Coding(c))
        })
    }
    return text
}

export function CodeableConcepts(codeableConcepts) {
    return codeableConcepts.map(c => {
        return CodeableConcept(c)
    }).toString().replace(/,/g, ', ')
}

export function Period(period) {
    let p = period.start ? moment(period.start).format('ll') : ''
    if (p.length && period.end) p += ' - '
    if (period.end) p += moment(period.end).format('ll')
    return p
}

export function Periods(periods) {
    return periods.map(p => Period(p)).toString().replace(/,/g, '\n')
}

export function PeriodStart(period) {
    return period && period.start ? moment(period.start).format('YYYY-MM-DD HH:mm') : ''
}

export function Money(money) {
    return `${money.value ? money.value : ''} ${money.currency ? '(' + money.currency + ')' : ''}`
}

export function Range(range) {
    if (range.code) return CodeableConcept(range.code)
    if (range.event) return moment(range.event).format('lll')
    if (range.duration) return `${range.duration} ${range.durationMax ? ' - ' + range.durationMax : ''} ${range.durationUnit} every ${range.frequency} ${range.frequencyMax ? ' - ' + range.frequencyMax : ''} ${range.period} ${range.periodUnit} ${range.dayOfWeek ? '(' + range.dayOfWeek + ')' : ''} ${range.timeOfDay ? '(' + range.timeOfDay + ')' : ''}`
}

export function Quantity(val) {
    return `${val.comparator ? val.comparator + ' ' : ''}${val.value ? val.value.toFixed(2) : ''}${val.unit ? ' ' + val.unit : (val.code ? ' ' + val.code : '')}`
}

export function Quantities(vals) {
    return vals.map(v => Quantity(v)).toString.replace(/,/g, '\n')
}

export function SampledData(sampledData) {
    return <pre>{JSON.stringify(sampledData, undefined, 2)}</pre>
}

export function ReferenceRange(referenceRange) {
    return <pre>{JSON.stringify(referenceRange, undefined, 2)}</pre>
}

export function Timing(timing) {
    return <pre>{JSON.stringify(timing, undefined, 2)}</pre>
}

export function Choice(type, val) {
    switch (type) {
        case 'Boolean':
            return val.toString()
        case 'CodeableConcept':
            return CodeableConcept(val)
        case 'Date':
            return moment(val).format('l')
        case 'DateTime':
            return moment(val).format('lll')
        case 'Instant':
            return moment(val).format('lll')
        case 'Period':
            return Period(val)
        case 'Quantity':
            return Quantity(val)
        case 'Range':
            return `${val.low ? Quantity(val.low) : ''}${val.low && val.high ? ' - ' : ''}${val.high ? Quantity(val.high) : ''}`
        case 'Ratio':
            return `${Quantity(val.numerator)} / ${Quantity(val.denominator)}`
        case 'SampledData':
            return SampledData(val)
        case 'Time':
            return moment(val).format('h:mm A')
        case 'Timing':
            return Timing(val)
        default:
            return val
    }
}

export function Ingredient(ingredient) {
    return <div>
        {(ingredient.itemCodeableConcept || ingredient.itemReference) && <div>
            <div className="Res-Row Res-Detail">
                {ingredient.itemCodeableConcept && <div className="Res-Title Resource-Left">Ingredient</div>}
                {ingredient.itemReference && <div className="Res-Title Resource-Right">Reference</div>}
            </div>
            <div className="Res-Row">
                {ingredient.itemCodeableConcept && <div className="Res-Detail Resource-Left">{CodeableConcept(ingredient.itemCodeableConcept)}</div>}
                {ingredient.itemReference && <div className="Res-Detail Resource-Right">{Reference(ingredient.itemReference)}</div>}
            </div>
        </div>}
        {(ingredient.isActive || ingredient.strength) && <div>
            <div className="Res-Row Res-Detail">
                {ingredient.isActive && <div className="Res-Title Resource-Left">Active</div>}
                {ingredient.strength && <div className="Res-Title Resource-Right">Strength</div>}
            </div>
            <div className="Res-Row">
                {ingredient.isActive && <div className="Res-Detail Resource-Left">{Choice('Boolean', ingredient.isActive)}</div>}
                {ingredient.strength && <div className="Res-Detail Resource-Right">{Choice('Ratio', ingredient.strength)}</div>}
            </div>
        </div>}
    </div>
}

export function Ingredients(ingredients) {
    return ingredients.map((ing, ingidx) => {
        return <div key={`pfmr-${ingidx}`}>{Ingredient(ing)}</div>
    })
}


export function Batch(batch) {
    <div>
        {(batch.lotNumber || batch.expirationDate) && <div>
            <div className="Res-Row Res-Detail">
                {batch.lotNumber && <div className="Res-Title Resource-Left">Ingredient</div>}
                {batch.expirationDate && <div className="Res-Title Resource-Right">Reference</div>}
            </div>
            <div className="Res-Row">
                {batch.lotNumber && <div className="Res-Detail Resource-Left">{batch.lotNumber}</div>}
                {batch.expirationDate && <div className="Res-Detail Resource-Right">{Choice('DateTime', batch.expirationDate)}</div>}
            </div>
        </div>}
    </div>
}


export function Annotation(annotation) {
    return `${annotation.authorReference ? Reference(annotation.authorReference) : (annotation.authorString ? annotation.authorString : '')} ${annotation.time ? '@' + moment(annotation.time).format('lll') + ': ' : ''}${annotation.text}`
}

//export function Annotation(annotation) {
//    return `${annotation.text ? annotation.text : ''} ${annotation.time ? '(' + moment(annotation.time).format('lll') + ')' : ''}${annotation.authorString ? ' - ' + annotation.authorString : ''}`
//}

export function Annotations(annotations) {
    return annotations.map(a => Annotation(a)).toString().replace(/,/g, '\n')
}

export function OnsetDateTime(onset) {
    return moment(onset).format('lll')
}

export function OnsetAge(onset) {
    return Code(onset)
}

export function OnsetPeriod(onset) {
    return Period(onset)
}

export function OnsetRange(onset) {
    return Range(onset)
}

export function OnsetString(onset) {
    return onset
}

export function Reaction(reaction) {
    return reaction.map((bb, bbidx) => {
        return (<div key={`reaction-${bb.id}-${bbidx}`} className="Mbrs-Reaction">
            {(bb.substance || bb.manifestation) && <div>
                <div className="Res-Row Res-Detail Res-Content-Rev">
                    {bb.substance && <div className="Res-Detail Mbrs-Reaction-Left">Substance</div>}
                    {bb.manifestation && <div className="Res-Detail Mbrs-Reaction-Right">Symptoms</div>}
                </div>
                <div className="Res-Row">
                    {bb.substance && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{CodeableConcept(bb.substance)}</div>}
                    {bb.manifestation && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{CodeableConcepts(bb.manifestation)}</div>}
                </div>
            </div>}
            {bb.description && <div className="Res-Row">{bb.description}</div>}
            {(bb.onset || bb.severity) && <div>
                <div className="Res-Row Res-Detail Res-Content-Rev">
                    {bb.onset && <div className="Res-Detail Mbrs-Reaction-Left">Onset</div>}
                    {bb.severity && <div className="Res-Detail Mbrs-Reaction-Right">severity</div>}
                </div>
                <div className="Res-Row">
                    {bb.onset && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{moment(bb.onset).format('l')}</div>}
                    {bb.severity && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{bb.severity}</div>}
                </div>
            </div>}
            {bb.exposureRoute && <div>
                <div className="Res-Row">
                    <div className="Res-Detail Mbrs-Reaction-Left">Exposure Route</div>
                </div>
                <div className="Res-Row">
                    <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{CodeableConcept(bb.exposureRoute)}</div>
                </div>
            </div>}
            {bb.note && <div className="Res-Row" style={{ fontStyle: 'italic' }}>{bb.note}</div>}
        </div>)
    })
}

//export function Name(name) {
//    return name && name[0] ? (name[0].text ? name[0].text : `${name[0].given.toString().replace(',', ' ')} ${name[0].family}`) : ''
//}

export function Reference(ref) {
    //need to finish this
    //bundle, resourceType, id
    //let ref = bundle && bundle.entry && bundle.entry[0] ? bundle.entry.filter(r => r.resource.resourceType === resourceType && r.resource.id === id) : null
    return ref.display || ref.reference
}

export function References(refs) {
    return refs.map(r => Reference(r)).toString().replace(/,/g, '\n')
}

export function Componentx(component) {
    return <div> <div className="Res-Row Res-Flex-Spread">
        <div className="Res-Detail Res-Content-Rev">Value</div>
        <div className="Res-Detail Res-Content-Rev">Type</div>
    </div>
        <div className="Res-Row Res-Flex-Spread">
            {component.valueQuantity && <div className="Res-Detail Resource-Left">{Choice('Quantity', component.valueQuantity)}</div>}
            {component.valueCodeableConcept && <div className="Res-Detail Resource-Left">{Choice('CodeableConcept', component.valueCodeableConcept)}</div>}
            {component.valueString && <div className="Res-Detail Resource-Left">{Choice('String', component.valueString)}</div>}
            {component.valueBoolean && <div className="Res-Detail Resource-Left">{Choice('Boolean', component.valueBoolean)}</div>}
            {component.valueInteger && <div className="Res-Detail Resource-Left">{Choice('Integer', component.valueInteger)}</div>}
            {component.valueRange && <div className="Res-Detail Resource-Left">{Choice('Range', component.valueRange)}</div>}
            {component.valueRatio && <div className="Res-Detail Resource-Left">{Choice('Ratio', component.valueRatio)}</div>}
            {component.valueSampledData && <div className="Res-Detail Resource-Left">{Choice('SampledData', component.valueSampledData)}</div>}
            {component.valueTime && <div className="Res-Detail Resource-Left">{Choice('Time', component.valueTime)}</div>}
            {component.valueDateTime && <div className="Res-Detail Resource-Left">{Choice('DateTime', component.valueDateTime)}</div>}
            {component.valuePeriod && <div className="Res-Detail Resource-Left">{Choice('Period', component.valuePeriod)}</div>}
            {component.code && <div className="Res-Detail Resource-Right">{CodeableConcept(component.code)}</div>}
        </div>
        {(component.dataAbsentReason || component.interpretation) && <div>
            <div className="Res-Row Res-Flex-Spread">
                {component.dataAbsentReason ? <div className="Res-Title Resource-Left">Missing Data</div> : <div></div>}
                {component.interpretation && <div className="Res-Title Resource-Right">Interpretation</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {component.dataAbsentReason ? <div className="Res-Detail Resource-Left">{CodeableConcept(component.dataAbsentReason)}</div> : <div></div>}
                {component.interpretation && <div className="Res-Detail Resource-Right">{CodeableConcepts(component.interpretation)}</div>}
            </div>
        </div>}
    </div>
}

export function Performer(performer) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Performer</div>
        </div>
        {performer.function && <div>
            <div className="Res-Row Res-Detail">
                {performer.function && <div className="Res-Title Resource-Left">Type</div>}
            </div>
            <div className="Res-Row">
                {performer.function && <div className="Res-Detail Resource-Left">{CodeableConcept(performer.function)}</div>}
            </div>
        </div>}
        {(performer.actor || performer.onBehalfOf) && <div>
            <div className="Res-Row Res-Detail">
                {performer.actor && <div className="Res-Title Resource-Left">Actor</div>}
                {performer.onBehalfOf && <div className="Res-Title Resource-Right">On Behalf Of</div>}
            </div>
            <div className="Res-Row">
                {performer.actor && <div className="Res-Detail Resource-Left">{Reference(performer.actor)}</div>}
                {performer.onBehalfOf && <div className="Res-Detail Resource-Right">{CodeableConcepts(performer.onBehalfOf)}</div>}
            </div>
        </div>}
    </div>
}

export function Performers(performers) {
    return performers.map((p, perfidx) => {
        return <div key={`pfmr-${perfidx}`}>{Performer(p)}</div>
    })
}

export function Components(components) {
    return components.map((comp, compidx) => {
        return (<div key={`comp-${compidx}`}>
            {Componentx(comp)}
        </div>)
    })
}

export function Stage(stage) {
    return stage.map((bb, bbidx) => {
        return (<div key={`stage-${bb.id}-${bbidx}`} className="Mbrs-Reaction">
            {(bb.summary || bb.assessment) && <div>
                <div className="Res-Row Res-Detail Res-Content-Rev">
                    {bb.summary && <div className="Res-Detail Mbrs-Reaction-Left">Summary</div>}
                    {bb.assessment && <div className="Res-Detail Mbrs-Reaction-Right">Assessment</div>}
                </div>
                <div className="Res-Row">
                    {bb.summary && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{CodeableConcept(bb.summary)}</div>}
                    {bb.assessment && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{CodeableConcepts(bb.assessment)}</div>}
                </div>
            </div>}
            {bb.type && <div>
                <div className="Res-Row">
                    <div className="Res-Detail Mbrs-Reaction-Left">Type</div>
                </div>
                <div className="Res-Row">
                    <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{CodeableConcept(bb.type)}</div>
                </div>
            </div>}
        </div>)
    })
}

export function Evidence(evidence) {
    return <div className="Mbrs-Reaction">
        {(evidence.code || evidence.detail) && <div>
            <div className="Res-Row Res-Detail Res-Content-Rev">
                {evidence.code && <div className="Res-Detail Mbrs-Reaction-Left">Symptoms</div>}
                {evidence.detail && <div className="Res-Detail Mbrs-Reaction-Right">Reference</div>}
            </div>
            <div className="Res-Row">
                {evidence.code && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{CodeableConcepts(evidence.code)}</div>}
                {evidence.detail && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{Reference(evidence.detail)}</div>}
            </div>
        </div>}
    </div>
}

export function StatusHistory(statusHistory) {
    return statusHistory.map((sh, shidx) => {
        return <div key={`sh-${shidx}`} className="Mbrs-Reaction">
            {(sh.status || sh.period) && <div>
                <div className="Res-Row Res-Detail Res-Content-Rev">
                    {sh.status && <div className="Res-Detail Mbrs-Reaction-Left">Status</div>}
                    {sh.detail && <div className="Res-Detail Mbrs-Reaction-Right">Reference</div>}
                </div>
                <div className="Res-Row">
                    {sh.status && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{Code(sh.status)}</div>}
                    {sh.detail && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{Period(sh.detail)}</div>}
                </div>
            </div>}
        </div>
    })
}

export function Participant(participant) {
    return participant.map((p, partidx) => {
        return <div key={`sh-${partidx}`} className="Mbrs-Reaction">
            {(p.individual || p.period) && <div>
                <div className="Res-Row Res-Flex-Spread">
                    {p.individual && <div className="Res-Detail Res-Content-Rev Mbrs-Reaction-Left">Participant</div>}
                    {p.period && <div className="Res-Detail Res-Content-Rev Mbrs-Reaction-Right">Period</div>}
                </div>
                <div className="Res-Row Res-Flex-Spread">
                    {p.individual && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{Reference(p.individual)}</div>}
                    {p.period && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{Period(p.period)}</div>}
                </div>
            </div>}
            {p.type && <div>
                <div className="Res-Row">
                    <div className="Res-Detail Res-Content-Rev Mbrs-Reaction-Left">Type</div>
                </div>
                <div className="Res-Row">
                    <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{CodeableConcepts(p.type)}</div>
                </div>
            </div>}
            {p.member && p.member.display && <div className="Res-Row Res-Detail">{p.member.display}</div>}
        </div>
    })
}

export function Duration(duration) {
    return <div className="Res-Row">
        <div style={{ height: '100px', width: '100%', overflowY: 'auto' }}><pre>{JSON.stringify(duration, undefined, 2)}</pre></div>
    </div>
}


export function Dosage(dosage) {
    return <div className="Res-Row">
        <div style={{ height: '100px', width: '100%', overflowY: 'auto' }}><pre>{JSON.stringify(dosage, undefined, 2)}</pre></div>
    </div>
}

export function Dosages(dosages) {
    return dosages.map((d, doseidx) => {
        return <div key={`dose-${doseidx}`}>{Dosage(d)}</div>
    })
}

export function Diagnosis(diagnosis) {
    return diagnosis.map((d, diagidx) => {
        return <div key={`sh-${diagidx}`} className="Mbrs-Reaction">
            {(d.condition || d.use || d.rank) && <div>
                <div className="Res-Row Res-Detail Res-Content-Rev">
                    {d.condition && <div style={{ width: '33%' }} className="Res-Detail Mbrs-Reaction-Left">Reference</div>}
                    {d.use && <div style={{ width: '33%' }} className="Res-Detail Mbrs-Reaction-Left">Role</div>}
                    {d.rank && <div style={{ width: '34%' }} className="Res-Detail Mbrs-Reaction-Right">Rank</div>}
                </div>
                <div className="Res-Row">
                    {d.condition && <div style={{ width: '33%' }} className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{Reference(d.condition)}</div>}
                    {d.use && <div style={{ width: '33%' }} className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{CodeableConcept(d.use)}</div>}
                    {d.rank && <div style={{ width: '34%' }} className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{d.rank}</div>}
                </div>
            </div>}
        </div>
    })
}

export function Hospitalization(hospitalization) {
    return <div className="Mbrs-Reaction">
        {hospitalization.preAdmissionIdentifier && SingleIdentifier(hospitalization.preAdmissionIdentifier)}
        {(hospitalization.origin || hospitalization.admitSource || hospitalization.reAdmission) && <div>
            <div className="Res-Row Res-Detail Res-Content-Rev">
                {hospitalization.origin && <div style={{ width: '33%' }} className="Res-Detail Mbrs-Reaction-Left">Origin</div>}
                {hospitalization.admitSource && <div style={{ width: '33%' }} className="Res-Detail Mbrs-Reaction-Left">Admit Source</div>}
                {hospitalization.reAdmission && <div style={{ width: '34%' }} className="Res-Detail Mbrs-Reaction-Right">Re-admission</div>}
            </div>
            <div className="Res-Row">
                {hospitalization.origin && <div style={{ width: '33%' }} className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{Reference(hospitalization.origin)}</div>}
                {hospitalization.admitSource && <div style={{ width: '33%' }} className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{CodeableConcept(hospitalization.admitSource)}</div>}
                {hospitalization.reAdmission && <div style={{ width: '34%' }} className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{CodeableConcept(hospitalization.reAdmission)}</div>}
            </div>
        </div>}
        {(hospitalization.dietPreference || hospitalization.specialCourtesy || hospitalization.specialArrangement) && <div>
            <div className="Res-Row Res-Detail Res-Content-Rev">
                {hospitalization.dietPreference && <div style={{ width: '33%' }} className="Res-Detail Mbrs-Reaction-Left">Diet</div>}
                {hospitalization.specialCourtesy && <div style={{ width: '33%' }} className="Res-Detail Mbrs-Reaction-Left">Courtesy</div>}
                {hospitalization.specialArrangement && <div style={{ width: '34%' }} className="Res-Detail Mbrs-Reaction-Right">Arrangements</div>}
            </div>
            <div className="Res-Row">
                {hospitalization.dietPreference && <div style={{ width: '33%' }} className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{CodeableConcepts(hospitalization.dietPreference)}</div>}
                {hospitalization.specialCourtesy && <div style={{ width: '33%' }} className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{CodeableConcepts(hospitalization.specialCourtesy)}</div>}
                {hospitalization.specialArrangement && <div style={{ width: '34%' }} className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{CodeableConcepts(hospitalization.specialArrangement)}</div>}
            </div>
        </div>}
        {(hospitalization.destination || hospitalization.dischargeDisposition) && <div>
            <div className="Res-Row Res-Detail Res-Content-Rev">
                {hospitalization.destination && <div className="Res-Detail Mbrs-Reaction-Left">Organization</div>}
                {hospitalization.dischargeDisposition && <div className="Res-Detail Mbrs-Reaction-Right">Discharged Reason</div>}
            </div>
            <div className="Res-Row">
                {hospitalization.destination && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{Reference(hospitalization.destination)}</div>}
                {hospitalization.dischargeDisposition && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{CodeableConcept(hospitalization.dischargeDisposition)}</div>}
            </div>
        </div>}
    </div>
}

export function Location(location) {
    return location.map((loc, locidx) => {
        return <div key={`loc-${locidx}`} className="Mbrs-Reaction">
            {(loc.location || loc.status) && <div>
                <div className="Res-Row Res-Detail Res-Content-Rev">
                    {loc.location && <div className="Res-Detail Mbrs-Reaction-Left">Reference</div>}
                    {loc.status && <div className="Res-Detail Mbrs-Reaction-Left">Status</div>}
                </div>
                <div className="Res-Row">
                    {loc.location && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{Reference(loc.location)}</div>}
                    {loc.status && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{loc.status}</div>}
                </div>
            </div>}
            {(loc.physicalType || loc.period) && <div>
                <div className="Res-Row Res-Detail Res-Content-Rev">
                    {loc.physicalType && <div className="Res-Detail Mbrs-Reaction-Left">Type</div>}
                    {loc.period && <div className="Res-Detail Mbrs-Reaction-Left">Period</div>}
                </div>
                <div className="Res-Row">
                    {loc.physicalType && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{CodeableConcept(loc.physicalType)}</div>}
                    {loc.period && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{Period(loc.period)}</div>}
                </div>
            </div>}
        </div>
    })
}

export function ClassHistory(classHistory) {
    return classHistory.map((ch, chidx) => {
        return <div key={`loc-${chidx}`} className="Mbrs-Reaction">
            {(ch.class || ch.period) && <div>
                <div className="Res-Row Res-Detail Res-Content-Rev">
                    {ch.class && <div className="Res-Detail Mbrs-Reaction-Left">Class</div>}
                    {ch.period && <div className="Res-Detail Mbrs-Reaction-Left">Period</div>}
                </div>
                <div className="Res-Row">
                    {ch.class && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{Coding(ch.class)}</div>}
                    {ch.period && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{Period(ch.period)}</div>}
                </div>
            </div>}
        </div>
    })
}

export function FocalDevice(focalDevice) {
    return <div>
        {(focalDevice.action || focalDevice.manipulation) && <div>
            <div className="Res-Row Res-Detail">
                {focalDevice.action && <div className="Res-Title Resource-Left">Device Action</div>}
                {focalDevice.manipulation && <div className="Res-Title Resource-Right">Device Manipulated</div>}
            </div>
            <div className="Res-Row">
                {focalDevice.action && <div className="Res-Detail Resource-Left">{CodeableConcept(focalDevice.action)}</div>}
                {focalDevice.manipulation && <div className="Res-Detail Resource-Right">{Reference(focalDevice.manipulation)}</div>}
            </div>
        </div>}
    </div>
}

export function FocalDevices(focalDevices) {
    return focalDevices.map((fd, fdidx) => {
        return <div key={`fd-${fdidx}`}>{FocalDevice(fd)}</div>
    })
}

export function Name(name) {
    return name.text ? name.text : `${name.prefix ? name.prefix.toString().replace(/\./g, '. ') : ''} ${name.given ? name.given.toString().replace(/,/g, ' ') : ''} ${name.family ? name.family : ''}${name.suffix ? name.suffix.toString().replace(/\./g, '. ') : ''} (${name.use || 'Unverified'})`
}

export function Names(names) {
    return names.map(n => Name(n)).toString().replace(/,/g, ', ')
}

export function ContactPoint(contactPoint) {
    return <div style={{ width: '100%' }}>
        {(contactPoint.system || contactPoint.value || contactPoint.use) && <div className="Res-Row">
            <div className=''>
                {contactPoint.system && <div className="Resource-Detail Res-Content-Rev">Contact Type</div>}
                {contactPoint.system && <div className="Resource-Detail">{contactPoint.system}</div>}
            </div>
            <div className=''>
                {contactPoint.value && <div className="Resource-Detail Res-Content-Rev">Contact</div>}
                {contactPoint.value && <div className="Resource-Detail">{contactPoint.value}</div>}
            </div>
            <div className=''>
                {contactPoint.use && <div className="Resource-Detail Res-Content-Rev">Contact Purpose</div>}
                {contactPoint.use && <div className="Resource-Detail">{contactPoint.use}</div>}
            </div>
        </div>}
        {(contactPoint.rank || contactPoint.period) && <div className='Res-Row Res-Row-Flex'>
            <div>
                {contactPoint.rank && <div className="Resource-Detail Res-Content-Rev">Contact Rank</div>}
                {contactPoint.rank && <div className="Resource-Detail">{contactPoint.rank}</div>}
            </div>
            <div>
                {contactPoint.period && <div className="Resource-Detail Res-Content-Rev">Contact Period</div>}
                {contactPoint.period && <div className="Resource-Detail">{Period(contactPoint.period)}</div>}
            </div>
        </div>}
    </div>
}

export function ContactPoints(contactPoints) {
    return contactPoints.map((cp, cpidx) => {
        return <div key={`cp-${cpidx}`}>{ContactPoint(cp)}</div>
    })
}

export function Address(address) {
    let addr = []
    if (address.line) addr = address.line.map(a => a)
    if (address.city) addr.push(address.city)
    if (address.state) addr.push(address.state)
    if (address.postalCode) addr.push(address.postalCode)
    return <div style={{ width: '100%' }}>
        {(address.use || address.type) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {address.use && <div className="Resource-Left">Address Use</div>}
                {address.type && <div className="Resource-Right">Address Type</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {address.use && <div className="Res-Title Resource-Left">{address.use}</div>}
                {address.type && <div className="Res-Title Resource-Right">{address.type}</div>}
            </div>
        </div>}
        <div className="Res-Row Res-Detail">
            <div className="Resource-Left">Address</div>
            {address.period && <div className="Resource-Right">Period</div>}
        </div>
        {address.text && <div className="Res-Row">
            <div className="Res-Title Resource-Left">{address.text}</div>
            {address.period && <div style={{ width: '30%' }} className="Res-Title Resource-Right">{Period(address.period)}</div>}
        </div>}
        {!address.text && <div className="Res-Row">
            <div className="Res-Title Resource-Left">{addr.toString().replace(/,/g, ', ')}</div>
            {address.period && <div style={{ width: '30%' }} className="Res-Title Resource-Right">{Period(address.period)}</div>}
        </div>}
    </div>
}

export function Addresses(addresses) {
    return addresses.map((addr, addridx) => {
        return <div key={`addr-${addridx}`}>{Address(addr)}</div>
    })
}

export function Contact(contact) {
    return <div>
        {(contact.relationship || contact.name) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {contact.relationship && <div className="Resource-Left">Relationship</div>}
                {contact.name && <div className="Resource-Right">Name</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {contact.relationship && <div className="Res-Title Resource-Left">{CodeableConcepts(contact.relationship)}</div>}
                {contact.name && <div className="Res-Title Resource-Right">{Name(contact.name)}</div>}
            </div>
        </div>}
        {contact.address && Address(contact.address)}
        {contact.telecom && Address(contact.telecom)}
        {(contact.organization || contact.period) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {contact.organization && <div className="Resource-Left">Organization</div>}
                {contact.period && <div className="Resource-Right">Period</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {contact.organization && <div className="Res-Title Resource-Left">{Reference(contact.organization)}</div>}
                {contact.period && <div className="Res-Title Resource-Right">{Period(contact.period)}</div>}
            </div>
        </div>}
    </div>
}

export function Contacts(contacts) {
    return contacts.map((cont, contidx) => {
        return <div key={`cont-${contidx}`}>{Contact(cont)}</div>
    })
}

export function Communication(communication) {
    return `${communication.language ? CodeableConcept(communication.language) : ''}${communication.preferred ? ' (' + communication.preferred + ')' : ''}`
}

export function Communications(communications) {
    return communications.map(c => Communication(c)).toString().replace(/,/g, ', ')
}

export function Link(link) {
    return <div>
        {(link.relationship || link.name) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {link.relationship && <div className="Resource-Left">Type</div>}
                {link.name && <div className="Resource-Right">Target</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {link.relationship && <div className="Res-Title Resource-Left">{link.type}</div>}
                {link.name && <div className="Res-Title Resource-Right">{Reference(link.other)}</div>}
            </div>
        </div>}
    </div>
}

export function Links(links) {
    return links.map((link, linkidx) => {
        return <div key={`lnk-${linkidx}`}>{Link(link)}</div>
    })
}

/* export function Identifier(identifier) {
    return <div className="Mbrs-Reaction">
        {(identifier.type || identifier.use || identifier.value) && <div>
            <div className="Res-Row Res-Detail Res-Content-Rev">
                {identifier.type && <div style={{ width: '33%' }} className="Res-Detail Mbrs-Reaction-Left">ID Type</div>}
                {identifier.use && <div style={{ width: '33%' }} className="Res-Detail Mbrs-Reaction-Left">Use</div>}
                {identifier.value && <div style={{ width: '34%' }} className="Res-Detail Mbrs-Reaction-Right">Value</div>}
            </div>
            <div className="Res-Row">
                {identifier.type && <div style={{ width: '33%' }} className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{CodeableConcept(identifier.type)}</div>}
                {identifier.use && <div style={{ width: '33%' }} className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{identifier.use}</div>}
                {identifier.value && <div style={{ width: '34%' }} className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{identifier.value}</div>}
            </div>
        </div>}
        {(identifier.period || identifier.assigner) && <div>
            <div className="Res-Row Res-Detail Res-Content-Rev">
                {identifier.assigner && <div className="Res-Detail Mbrs-Reaction-Left">Assigner</div>}
                {identifier.period && <div className="Res-Detail Mbrs-Reaction-Right">Period</div>}
            </div>
            <div className="Res-Row">
                {identifier.assigner && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Left">{Reference(identifier.assigner)}</div>}
                {identifier.period && <div className="Mbrs-Reaction-Value Mbrs-Reaction-Right">{Period(identifier.period)}</div>}
            </div>
        </div>}
    </div>
} */

export function DispenseRequest(dispenseRequest) {
    return <div>
        {(dispenseRequest.initialFill) &&
            <div className="Res-Row Res-Detail">
                <div style={{ textAlign: 'center' }} className="Res-Content-Rev">Initial Fill</div>
            </div>}{
            (dispenseRequest.initialFill && dispenseRequest.initialFill.quantity) && <div>
                <div className="Res-Row Res-Detail">Quantity</div>
                <div className="Res-Title Resource-Left">{Quantity(dispenseRequest.initialFill.quantity)}</div>
            </div>
        }{
            (dispenseRequest.initialFill && dispenseRequest.initialFill.duration) && <div>
                <div className="Res-Row Res-Detail">Duration</div>
                {Duration(dispenseRequest.initialFill.duration)}
            </div>
        }{
            (dispenseRequest.interval) && <div>
                <div className="Res-Row Res-Detail">Dispense Interval</div>
                {Duration(dispenseRequest.interval)}
            </div>
        }{
            (dispenseRequest.validityPeriod || dispenseRequest.numberOfRepeatsAllowed) && <div>
                <div className="Res-Row Res-Detail Res-Flex-Spread">
                    {dispenseRequest.validityPeriod && <div className="Resource-Left">Period</div>}
                    {dispenseRequest.numberOfRepeatsAllowed && <div className="Resource-Right">Re-fills</div>}
                </div>
                <div className="Res-Row Res-Flex-Spread">
                    {dispenseRequest.validityPeriod && <div className="Res-Title Resource-Left">{Period(dispenseRequest.validityPeriod)}</div>}
                    {dispenseRequest.numberOfRepeatsAllowed && <div className="Res-Title Resource-Right">{dispenseRequest.numberOfRepeatsAllowed}</div>}
                </div>
            </div>
        }{
            (dispenseRequest.quantity) && <div>
                <div className="Res-Row Res-Detail">
                    <div className="Resource-Left">Quantity</div>
                    <div className="Res-Title Resource-Left">{Quantity(dispenseRequest.quantity)}</div>
                </div>
            </div>
        }
        {
            (dispenseRequest.expectedSupplyDuration) && <div>
                <div className="Res-Row Res-Detail">Expected Duration</div>
                {Duration(dispenseRequest.expectedSupplyDuration)}
            </div>
        }
        {
            (dispenseRequest.performer) && <div>
                <div className="Res-Row Res-Detail">Despenser</div>
                <div className="Res-Row">
                    <div className="Res-Title Resource-Left">{Reference(dispenseRequest.performer)}</div>
                </div>
            </div>
        }
    </div>
}

export function Substitution(substitution) {
    return <div>
        {(substitution.allowedBoolean || substitution.allowedCodeableConcept || substitution.reason) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {(substitution.allowedBoolean || substitution.allowedCodeableConcept) ? <div className="Resource-Left">Substitution Allowed</div> : <div></div>}
                {substitution.reason && <div className="Resource-Right">Reason</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {substitution.allowedBoolean && <div className="Res-Title Resource-Left">{Choice('Boolean', substitution.allowedBoolean)}</div>}
                {substitution.allowedCodeableConcept && <div className="Res-Title Resource-Left">{CodeableConcept(substitution.allowedCodeableConcept)}</div>}
                {substitution.reason && <div className="Res-Title Resource-Right">{CodeableConcept(substitution.reason)}</div>}
            </div>
        </div>}
    </div>
}

export function DeviceName(deviceName) {
    return <div>
        {(deviceName.name || deviceName.type) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {deviceName.name && <div className="Resource-Left">Device Name</div>}
                {deviceName.type && <div className="Resource-Right">Device Type</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {deviceName.name && <div className="Res-Title Resource-Left">{deviceName.name}</div>}
                {deviceName.type && <div className="Res-Title Resource-Right">{deviceName.type}</div>}
            </div>
        </div>}
    </div>
}


export function DeviceNames(deviceNames) {
    return deviceNames.map((dn, dnidx) => {
        return <div key={`dev-${dnidx}`}>{DeviceName(dn)}</div>
    })
}

export function UDICarrier(udiCarrier) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Device Carrier</div>
        </div>
        {(udiCarrier.deviceIdentifier || udiCarrier.entryType) && <div className='Res-Row'>
            <div className="Res-Detail Res-Flex-Spread">
                {udiCarrier.deviceIdentifier && <div className="Resource-Left">ID</div>}
                {udiCarrier.entryType && <div className="Resource-Right">Issuer</div>}
            </div>
            <div className="Res-Flex-Spread">
                {udiCarrier.deviceIdentifier && <div className="Res-Title Resource-Left">{udiCarrier.deviceIdentifier}</div>}
                {udiCarrier.entryType && <div className="Res-Title Resource-Right">{udiCarrier.entryType}</div>}
            </div>
        </div>}
        {(udiCarrier.issuer || udiCarrier.jurisdiction) && <div className='Res-Row'>
            <div className="Res-Detail Res-Flex-Spread">
                {udiCarrier.issuer && <div className="Resource-Left">Issuer</div>}
                {udiCarrier.jurisdiction && <div className="Resource-Right">Jurisdiction</div>}
            </div>
            <div className="Res-Flex-Spread">
                {udiCarrier.issuer && <div className="Res-Title Resource-Left">{udiCarrier.issuer}</div>}
                {udiCarrier.jurisdiction && <div className="Res-Title Resource-Right">{udiCarrier.jurisdiction}</div>}
            </div>
        </div>}
        {udiCarrier.carrierHRF && <div className="Res-Row">
            <div className="Res-Detail">
                {udiCarrier.carrierHRF && <div className="Resource-Left">HRF</div>}
            </div>
            <div>
                {udiCarrier.carrierHRF && <div className="Res-Title Resource-Left">{udiCarrier.carrierHRF}</div>}
            </div>
        </div>}
        {udiCarrier.carrierAIDC && <div className="Res-Row">
            <div className="Res-Detail">
                {udiCarrier.carrierAIDC && <div className="Resource-Left">AIDC</div>}
            </div>
            <div className="">
                {udiCarrier.carrierAIDC && <div className="Res-Title Resource-Left"><Barcode width={1} height={20} margin={1} fontSize={8} value={Buffer.from(udiCarrier.carrierAIDC, 'base64').toString('ascii')} /></div>}
            </div>
        </div>}
    </div>
}

export function UDICarriers(udiCarriers) {
    return udiCarriers.map((udi, udiidx) => {
        return <div key={`udi-${udiidx}`}>{UDICarrier(udi)}</div>
    })
}

export function Specialization(specialization) {
    return `${specialization.systemType ? CodeableConcept(specialization.systemType) : ''} ${specialization.version ? '(version: ' + specialization.version + ')' : ''}`
}

export function Specializations(specializations) {
    return specializations.map(s => Specialization(s)).toString().replace(/,/g, '\n')
}

export function Version(version) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Version</div>
        </div>
        {(version.type || version.value) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {version.type && <div className="Resource-Left">Type</div>}
                {version.value && <div className="Resource-Right">Version</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {version.type && <div className="Res-Title Resource-Left">{CodeableConcept(version.type)}</div>}
                {version.value && <div className="Res-Title Resource-Right">{version.value}</div>}
            </div>
            {version.component && Identifier(version.component)}
        </div>}
    </div>
}

export function Versions(versions) {
    return versions.map((v, vsidx) => {
        return <div key={`ver-${vsidx}`}>{Version(v)}</div>
    })
}

export function Property(property) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Property</div>
        </div>
        {(property.type || property.valueCode) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {property.type && <div className="Resource-Left">Type</div>}
                {property.valueCode && <div className="Resource-Right">Value</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {property.type && <div className="Res-Title Resource-Left">{CodeableConcept(property.type)}</div>}
                {property.valueCode && <div className="Res-Title Resource-Right">{CodeableConcepts(property.valueCode)}</div>}
            </div>
        </div>}
        {property.valueQuantity && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Quantity</div>
            </div>
            <div className="Res-Row">
                <div className="Res-Title Resource-Left">{CodeableConcepts(property.valueQuantity)}</div>
            </div>
        </div>}
    </div>
}

export function Properties(properties) {
    return properties.map((prop, propidx) => {
        return <div key={`prop-${propidx}`}>{Property(prop)}</div>
    })
}

export function Education(education) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Education</div>
        </div>
        {(education.documentType || education.reference) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {education.documentType && <div className="Resource-Left">Type</div>}
                {education.reference && <div className="Resource-Right">URL</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {education.documentType && <div className="Res-Title Resource-Left">{education.documentType}</div>}
                {education.reference && <div className="Res-Title Resource-Right">{education.reference}</div>}
            </div>
        </div>}
        {(education.publicationDate || education.presentationDate) && <div>
            <div className="Res-Row Res-Detai Res-Flex-Spreadl">
                {education.publicationDate && <div className="Resource-Left">Published</div>}
                {education.presentationDate && <div className="Resource-Right">Presented</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {education.publicationDate && <div className="Res-Title Resource-Left">{Choice('DateTime', education.publicationDate)}</div>}
                {education.presentationDate && <div className="Res-Title Resource-Right">{Choice('DateTime', education.presentationDate)}</div>}
            </div>
        </div>}
    </div>
}

export function Educations(educations) {
    return educations.map((ed, edidx) => {
        return <div key={`ed-${edidx}`}>{Education(ed)}</div>
    })
}

export function ImmzReaction(reaction) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Reaction</div>
        </div>
        {(reaction.date || reaction.detail || reaction.reported) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {reaction.date && <div className="Resource-Left">Date</div>}
                {reaction.detail && <div className="Resource-Left">Detail</div>}
                {reaction.reported && <div className="Resource-Right">Reported</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {reaction.date && <div className="Res-Title Resource-Left">{Choice('DateTime', reaction.date)}</div>}
                {reaction.detail && <div className="Res-Title Resource-Left">{Reference(reaction.detail)}</div>}
                {reaction.reported && <div className="Res-Title Resource-Right">{Choice('Boolean', reaction.reported)}</div>}
            </div>
        </div>}
    </div>
}

export function ImmzReactions(reactions) {
    return reactions.map((ireact, ireactidx) => {
        return <div key={`immzreact-${ireactidx}`}>{ImmzReaction(ireact)}</div>
    })
}

export function ProtocolApplied(protocol) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Protocol</div>
        </div>
        {(protocol.series || protocol.authority) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {protocol.series && <div className="esource-Left">Series</div>}
                {protocol.authority && <div className="Resource-Right">Authority</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {protocol.series && <div className="Res-Title Resource-Left">{Choice('DateTime', protocol.series)}</div>}
                {protocol.authority && <div className="Res-Title Resource-Right">{Reference(protocol.authority)}</div>}
            </div>
        </div>}
        {protocol.targetDisease && <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>{CodeableConcepts(protocol.targetDisease)}</div>
        </div>}
        {(protocol.doseNumberPositiveInt || protocol.doseNumberString || protocol.seriesDosesPositiveInt || protocol.seriesDosesString) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {(protocol.doseNumberPositiveInt || protocol.doseNumberString) && <div className="Resource-Left">Number of Doses</div>}
                {(protocol.seriesDosesPositiveInt || protocol.seriesDosesString) && <div className="Resource-Left">Series</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {protocol.doseNumberPositiveInt && <div className="Res-Title Resource-Left">{protocol.doseNumberPositiveInt}</div>}
                {protocol.doseNumberString && <div className="Res-Title Resource-Left">{protocol.doseNumberString}</div>}
                {protocol.seriesDosesPositiveInt && <div className="Res-Title Resource-Right">{protocol.seriesDosesPositiveInt}</div>}
                {protocol.seriesDosesString && <div className="Res-Title Resource-Right">{protocol.seriesDosesString}</div>}
            </div>
        </div>}
    </div>
}

export function ProtocolsApplied(protocols) {
    return protocols.map((p, prclidx) => {
        return <div key={`protocol-${prclidx}`}>{ProtocolApplied(p)}</div>
    })
}

export function Media(media) {
    return <div>
        {(media.comment || media.link) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {media.comment && <div className="Resource-Left">Image Comment</div>}
                {media.link && <div className="Resource-Right">Image Source</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {media.comment && <div className="Res-Title Resource-Left">{media.comment}</div>}
                {media.link && <div className="Res-Title Resource-Right">{Reference(media.link)}</div>}
            </div>
        </div>}
    </div>
}

export function Medias(medias) {
    return medias.map((m, medidx) => {
        return <div key={`media-${medidx}`}>{Media(m)}</div>
    })
}

export function Attachment(attachment) {
    let ext = mimes.findIndex(m => m.type === attachment.contentType || '')

    return ext > -1 ? <div className="Res-Row">
        <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}><a href={`data:application/octet-stream;base64,${attachment.data}`} download={`file.${mimes[ext].ext}`}>{attachment.title || 'View Documentation'}</a></div>
    </div> : <div></div>
}

export function Attachments(attachments) {
    return attachments.map((a, attchidx) => {
        return <div key={`attach-${attchidx}`}>{Attachment(a)}</div>
    })
}

export function TeamMember(teamMember) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Team Member</div>
        </div>
        {(teamMember.role || teamMember.member) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {teamMember.role && <div className="Resource-Left">Role</div>}
                {teamMember.member && <div className="Resource-Right">Member</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {teamMember.role && <div className="Res-Title Resource-Left">{CodeableConcepts(teamMember.role)}</div>}
                {teamMember.member && <div className="Res-Title Resource-Right">{Reference(teamMember.member)}</div>}
            </div>
        </div>}
        {(teamMember.onBehalfOf || teamMember.period) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {teamMember.onBehalfOf && <div className="Resource-Left">Organization</div>}
                {teamMember.period && <div className="Resource-Right">Period</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {teamMember.onBehalfOf && <div className="Res-Title Resource-Left">{Reference(teamMember.onBehalfOf)}</div>}
                {teamMember.period && <div className="Res-Title Resource-Right">{Period(teamMember.period)}</div>}
            </div>
        </div>}
    </div>
}

export function TeamMembers(teamMembers) {
    return teamMembers.map((tm, tmidx) => {
        return <div key={`attach-${tmidx}`}>{TeamMember(tm)}</div>
    })
}

export function Activity(activity) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Activity</div>
        </div>
        {(activity.outcomeCodeableConcept || activity.outcomeReference) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {activity.outcomeCodeableConcept && <div className="Resource-Left">Role</div>}
                {activity.outcomeReference && <div className="Resource-Right">Member</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {activity.outcomeCodeableConcept && <div className="Res-Title Resource-Left">{CodeableConcepts(activity.outcomeCodeableConcept)}</div>}
                {activity.outcomeReference && <div className="Res-Title Resource-Right">{References(activity.outcomeReference)}</div>}
            </div>
        </div>}
        {activity.reference && <div className="Res-Row Res-Detail">
            <div className="Resource-Left">Goal</div>
            <div className="Res-Title Res-Row">{Reference(activity.reference)}</div>
        </div>}
        {activity.detail && Detail(activity.detail)}
        {activity.progress && <div className="Res-Row Resource-Left" style={{ fontStyle: 'italic' }}>{Annotations(activity.progress)}</div>}
    </div>
}

export function Activities(activities) {
    return activities.map((act, actidx) => {
        return <div key={`act-${actidx}`}>{Activity(act)}</div>
    })
}

export function Detail(detail) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Details</div>
        </div>
        {(detail.kind || detail.code) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.kind && <div className="Resource-Left">Kind</div>}
                {detail.code && <div className="Resource-Right">Type</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.kind && <div className="Res-Title Resource-Left">{detail.kind}</div>}
                {detail.code && <div className="Res-Title Resource-Right">{CodeableConcept(detail.code)}</div>}
            </div>
        </div>}
        {(detail.reasonCode || detail.reasonReference) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.reasonCode && <div className="Resource-Left">Reason</div>}
                {detail.reasonReference && <div className="Resource-Right">Reason Reference</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.reasonCode && <div className="Res-Title Resource-Left">{CodeableConcepts(detail.reasonCode)}</div>}
                {detail.reasonReference && <div className="Res-Title Resource-Right">{References(detail.reasonReference)}</div>}
            </div>
        </div>}
        {(detail.status || detail.statusReason) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.status && <div className="Resource-Left">Status</div>}
                {detail.statusReason && <div className="Resource-Right">Status Reason</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.status && <div className="Res-Title Resource-Left">{detail.status}</div>}
                {detail.statusReason && <div className="Res-Title Resource-Right">{CodeableConcept(detail.statusReason)}</div>}
            </div>
        </div>}
        {(detail.goal || detail.doNotPerform) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.goal && <div className="Resource-Left">Goal</div>}
                {detail.doNotPerform && <div className="Resource-Right">Prohibited</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.goal && <div className="Res-Title Resource-Left">{References(detail.goal)}</div>}
                {detail.doNotPerform && <div className="Res-Title Resource-Right">{Choice('Boolean', detail.doNotPerform)}</div>}
            </div>
        </div>}
        {(detail.scheduledTiming || detail.scheduledPeriod || detail.scheduledString) && <div>
            <div className="Resource-Left">Schedule</div>
        </div>}
        {detail.scheduledTiming && <div className="Res-Row">{Choice('Timing', detail.scheduledTiming)}</div>}
        {detail.scheduledPeriod && <div className="Res-Row">
            <div className="Res-Title Resource-Left">{Choice('Period', detail.scheduledPeriod)}</div>
        </div>}
        {detail.scheduledString && <div className="Res-Row">
            <div className="Res-Title Resource-Left">{detail.scheduledString}</div>
        </div>}
        {(detail.location || detail.performer) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.location && <div className="Resource-Left">Location</div>}
                {detail.performer && <div className="Resource-Right">Performer</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.location && <div className="Res-Title Resource-Left">{Reference(detail.location)}</div>}
                {detail.performer && <div className="Res-Title Resource-Right">{References(detail.performer)}</div>}
            </div>
        </div>}
        {(detail.productCodeableConcept || detail.productReference) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.productCodeableConcept && <div className="Resource-Left">Product</div>}
                {detail.productReference && <div className="Resource-Right">Product Reference</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.productCodeableConcept && <div className="Res-Title Resource-Left">{CodeableConcept(detail.productCodeableConcept)}</div>}
                {detail.productReference && <div className="Res-Title Resource-Right">{Reference(detail.productReference)}</div>}
            </div>
        </div>}
        {(detail.dailyAmount || detail.quantity) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.dailyAmount && <div className="Resource-Left">Daily Amount</div>}
                {detail.quantity && <div className="Resource-Right">Quantity</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.dailyAmount && <div className="Res-Title Resource-Left">{Quantity(detail.dailyAmount)}</div>}
                {detail.quantity && <div className="Res-Title Resource-Right">{Quantity(detail.quantity)}</div>}
            </div>
        </div>}
        {detail.description && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Description</div>
            </div>
            <div className="Res-Row">
                <div className="Res-Title Resource-Left">{detail.goal}</div>
            </div>
        </div>}
    </div>
}

export function Target(target) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Target</div>
        </div>
        {(target.measure || target.detailQuantity || target.detailRange || target.detailCodeableConcept || target.detailString || target.detailBoolean || target.detailInteger || target.detailRatio) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {target.measure && <div className="Resource-Left">Measure</div>}
                {(target.detailQuantity || target.detailRange || target.detailCodeableConcept || target.detailString || target.detailBoolean || target.detailInteger || target.detailRatio) && <div className="Resource-Right">Target</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {target.measure && <div className="Res-Title Resource-Left">{CodeableConcept(target.measure)}</div>}
                {target.detailQuantity && <div className="Res-Title Resource-Right">{Choice('Quantity', target.detailQuantity)}</div>}
                {target.detailRange && <div className="Res-Title Resource-Right">{Choice('Range', target.detailRange)}</div>}
                {target.detailCodeableConcept && <div className="Res-Title Resource-Right">{Choice('CodeableConcept', target.detailCodeableConcept)}</div>}
                {target.detailString && <div className="Res-Title Resource-Right">{Choice('String', target.detailString)}</div>}
                {target.detailBoolean && <div className="Res-Title Resource-Right">{Choice('Boolean', target.detailBoolean)}</div>}
                {target.detailInteger && <div className="Res-Title Resource-Right">{Choice('Integer', target.detailInteger)}</div>}
                {target.detailRatio && <div className="Res-Title Resource-Right">{Choice('Ratio', target.detailRatio)}</div>}
            </div>
        </div>}
        {(target.dueDate || target.dueDuration) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {target.dueDate && <div className="Resource-Left">Due Date</div>}
                {target.dueDuration && <div className="Resource-Right">Duration</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {target.dueDate && <div className="Res-Title Resource-Left">{Choice('Date', target.dueDate)}</div>}
                {target.dueDuration && <div className="Res-Title Resource-Right">{Choice('Duration', target.dueDuration)}</div>}
            </div>
        </div>}
    </div>
}

export function Targets(targets) {
    return targets.map((tar, taridx) => {
        return <div key={`target-${taridx}`}>{Target(tar)}</div>
    })
}
//add Res-Flex-Spread
export function Related(related) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Prior or Corollary Claims</div>
        </div>
        {(related.claim || related.relationship) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {related.claim && <div className="Resource-Left">Claim</div>}
                {related.relationship && <div className="Resource-Right">Relationship</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {related.claim && <div className="Res-Title Resource-Left">{Reference(related.claim)}</div>}
                {related.relationship && <div className="Res-Title Resource-Right">{CodeableConcept(related.relationship)}</div>}
            </div>
        </div>}
        {related.reference && Identifier(related.reference)}
    </div>
}

export function Relateds(relateds) {
    return relateds.map((rel, relidx) => {
        return <div key={`rel-${relidx}`}>{Target(rel)}</div>
    })
}

export function Payee(payee) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Payee</div>
        </div>
        {(payee.type || payee.party) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {payee.type && <div className="Resource-Left">Type</div>}
                {payee.party && <div className="Resource-Right">Party</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {payee.type && <div className="Res-Title Resource-Left">{CodeableConcept(payee.type)}</div>}
                {payee.party && <div className="Res-Title Resource-Right">{Reference(payee.party)}</div>}
            </div>
        </div>}
    </div>
}

export function CareTeam(careTeam) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Care Team</div>
        </div>
        {(careTeam.sequence || careTeam.provider) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {careTeam.sequence && <div className="Resource-Left">Sequence</div>}
                {careTeam.provider && <div className="Resource-Right">Provider</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {careTeam.sequence && <div className="Res-Title Resource-Left">{careTeam.sequence}</div>}
                {careTeam.provider && <div className="Res-Title Resource-Right">{Reference(careTeam.provider)}</div>}
            </div>
        </div>}
        {(careTeam.responsible || careTeam.role) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {careTeam.responsible && <div className="Resource-Left">Lead</div>}
                {careTeam.role && <div className="Resource-Right">Role</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {careTeam.responsible && <div className="Res-Title Resource-Left">{Choice('Boolean', careTeam.responsible)}</div>}
                {careTeam.role && <div className="Res-Title Resource-Right">{CodeableConcept(careTeam.role)}</div>}
            </div>
        </div>}
        {careTeam.qualification && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Qualification</div>
                <div className="Res-Title Resource-Left">{CodeableConcept(careTeam.qualification)}</div>
            </div>
        </div>}
    </div>
}

export function CareTeams(careTeams) {
    return careTeams.sort((a, b) => {
        let x = a.sequence
        let y = b.sequence
        if (x < y) return -1
        if (x > y) return 1
        return 0
    }).map((ct, caretidx) => {
        return <div key={`ct-${caretidx}`}>{CareTeam(ct)}</div>
    })
}

export function SupportingInfo(supportingInfo) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Supporting Information</div>
        </div>
        {(supportingInfo.sequence || supportingInfo.category) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {supportingInfo.sequence && <div className="Resource-Left">Sequence</div>}
                {supportingInfo.category && <div className="Resource-Right">Classification</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {supportingInfo.sequence && <div className="Res-Title Resource-Left">{supportingInfo.sequence}</div>}
                {supportingInfo.category && <div className="Res-Title Resource-Right">{CodeableConcept(supportingInfo.category)}</div>}
            </div>
        </div>}
        {(supportingInfo.code || supportingInfo.timingDate || supportingInfo.timingPeriod) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {supportingInfo.code && <div className="Resource-Left">Information Type</div>}
                {(supportingInfo.timingDate || supportingInfo.timingPeriod) && <div className="Resource-Right">Occurrence</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {supportingInfo.code && <div className="Res-Title Resource-Left">{CodeableConcept(supportingInfo.code)}</div>}
                {supportingInfo.timingDate && <div className="Res-Title Resource-Right">{Choice('Date', supportingInfo.timingDate)}</div>}
                {supportingInfo.timingPeriod && <div className="Res-Title Resource-Right">{Choice('Period', supportingInfo.timingPeriod)}</div>}
            </div>
        </div>}
        {(supportingInfo.valueBoolean || supportingInfo.valueString || supportingInfo.valueQuantity || supportingInfo.valueAttachment || supportingInfo.valueReference || supportingInfo.reason) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {(supportingInfo.valueBoolean || supportingInfo.valueString || supportingInfo.valueQuantity || supportingInfo.valueAttachment || supportingInfo.valueReference) && <div className="Resource-Left">Data</div>}
                {supportingInfo.reason && <div className="Resource-Right">Explanation</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {supportingInfo.valueBoolean && <div className="Res-Title Resource-Left">{Choice('Boolean', supportingInfo.valueBoolean)}</div>}
                {supportingInfo.valueString && <div className="Res-Title Resource-Left">{supportingInfo.valueString}</div>}
                {supportingInfo.valueQuantity && <div className="Res-Title Resource-Left">{Choice('Quantity', supportingInfo.valueQuantity)}</div>}
                {supportingInfo.valueAttachment && <div className="Res-Title Resource-Left">{Attachment(supportingInfo.valueAttachment)}</div>}
                {supportingInfo.valueReference && <div className="Res-Title Resource-Left">{Reference(supportingInfo.valueReference)}</div>}
                {supportingInfo.reason && <div className="Res-Title Resource-Right">{Coding(supportingInfo.reason)}</div>}
            </div>
        </div>}
    </div>
}

export function SupportingInfos(supportingInfos) {
    return supportingInfos.sort((a, b) => {
        let x = a.sequence
        let y = b.sequence
        if (x < y) return -1
        if (x > y) return 1
        return 0
    }).map((si, siidx) => {
        return <div key={`ct-${siidx}`}>{SupportingInfo(si)}</div>
    })
}

export function ClaimDiagnosis(diagnosis) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Payee</div>
        </div>
        {(diagnosis.sequence || diagnosis.diagnosisCodeableConcept || diagnosis.diagnosisReference) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {diagnosis.sequence && <div className="Resource-Left">Sequence</div>}
                {(diagnosis.diagnosisCodeableConcept || diagnosis.diagnosisReference) && <div className="Resource-Right">Diagnosis</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {diagnosis.sequence && <div className="Res-Title Resource-Left">{diagnosis.sequence}</div>}
                {diagnosis.diagnosisCodeableConcept && <div className="Res-Title Resource-Right">{CodeableConcept(diagnosis.diagnosisCodeableConcept)}</div>}
                {diagnosis.diagnosisReference && <div className="Res-Title Resource-Right">{Reference(diagnosis.diagnosisReference)}</div>}
            </div>
        </div>}
        {diagnosis.type && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Nature of Diagnosis</div>
                <div className="Res-Title Resource-Left">{CodeableConcepts(diagnosis.type)}</div>
            </div>
        </div>}
        {(diagnosis.onAdmission || diagnosis.packageCode) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {diagnosis.onAdmission && <div className="Resource-Left">Present on Admission</div>}
                {diagnosis.packageCode && <div className="Resource-Right">Billing Code</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {diagnosis.onAdmission && <div className="Res-Title Resource-Left">{CodeableConcept(diagnosis.onAdmission)}</div>}
                {diagnosis.packageCode && <div className="Res-Title Resource-Right">{CodeableConcept(diagnosis.packageCode)}</div>}
            </div>
        </div>}
    </div>
}

export function Diagnosiss(diagnosiss) {
    return diagnosiss.sort((a, b) => {
        let x = a.sequence
        let y = b.sequence
        if (x < y) return -1
        if (x > y) return 1
        return 0
    }).map((diag, diagidx) => {
        return <div key={`diag-${diagidx}`}>{ClaimDiagnosis(diag)}</div>
    })
}

export function Procedure(procedure) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Procedure</div>
        </div>
        {(procedure.sequence || procedure.type) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {procedure.sequence && <div className="Resource-Left">Sequence</div>}
                {procedure.type && <div className="Resource-Right">Billing Code</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {procedure.sequence && <div className="Res-Title Resource-Left">{procedure.sequence}</div>}
                {procedure.type && <div className="Res-Title Resource-Right">{CodeableConcepts(procedure.type)}</div>}
            </div>
        </div>}
        {(procedure.date || procedure.procedureCodeableConcept || procedure.procedureReference) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {procedure.date && <div className="Resource-Left">Date</div>}
                {(procedure.procedureCodeableConcept || procedure.procedureReference) && <div className="Resource-Right">Procedure</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {procedure.date && <div className="Res-Title Resource-Left">{Choice('DateTime', procedure.date)}</div>}
                {procedure.procedureCodeableConcept && <div className="Res-Title Resource-Right">{CodeableConcept(procedure.procedureCodeableConcept)}</div>}
                {procedure.procedureReference && <div className="Res-Title Resource-Right">{Reference(procedure.procedureReference)}</div>}
            </div>
        </div>}
        {procedure.udi && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Device</div>
            </div>
            <div className="Res-Row">
                <div className="Res-Title Resource-Left">{References(procedure.type)}</div>
            </div>
        </div>}
    </div>
}

export function Procedures(procedures) {
    return procedures.sort((a, b) => {
        let x = a.sequence
        let y = b.sequence
        if (x < y) return -1
        if (x > y) return 1
        return 0
    }).map((proc, procidx) => {
        return <div key={`proc-${procidx}`}>{Procedure(proc)}</div>
    })
}

export function Insurance(insurance) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Insurance</div>
        </div>
        {(insurance.focal || insurance.coverage) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {insurance.focal && <div className="">Coverage for Adjudication</div>}
                {insurance.coverage && <div className="">Coverage</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread Res-Title">
                {insurance.focal && <div className="">{Choice('Boolean', insurance.focal)}</div>}
                {insurance.coverage && <div className="">{Reference(insurance.coverage)}</div>}
            </div>
        </div>}
        {insurance.preAuthRef && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Reference</div>
            </div>
            <div className="Res-Row">
                <div className="Res-Title Resource-Left">{Code(insurance.preAuthRef)}</div>
            </div>
        </div>}
    </div>
}

export function Insurances(insurances) {
    return insurances.map((ins, insidx) => {
        return <div key={`ins-${insidx}`}>{Insurance(ins)}</div>
    })
}

export function Accident(accident) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Accident</div>
        </div>
        {(accident.date || accident.type) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {accident.date && <div className="Resource-Left">Coverage for Adjudication</div>}
                {accident.type && <div className="Resource-Right">Coverage</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {accident.date && <div className="Res-Title Resource-Left">{Choice('Date', accident.date)}</div>}
                {accident.type && <div className="Res-Title Resource-Right">{CodeableConcept(accident.type)}</div>}
            </div>
        </div>}
        {accident.locationAddress & Address(accident.locationAddress)}
        {accident.locationReference && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Address</div>
            </div>
            <div className="Res-Row">
                <div className="Res-Title Resource-Left">{Reference(accident.locationAddress)}</div>
            </div>
        </div>}
    </div>
}

export function Adjudication(adjudication) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Adjudication</div>
        </div>
        {(adjudication.category || adjudication.reason) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {adjudication.category && <div className="Resource-Left">Adjudication Type</div>}
                {adjudication.reason && <div className="Resource-Right">Explanation</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {adjudication.category && <div className="Res-Title Resource-Left">{CodeableConcept(adjudication.category)}</div>}
                {adjudication.reason && <div className="Res-Title Resource-Right">{CodeableConcept(adjudication.reason)}</div>}
            </div>
        </div>}
        {(adjudication.amount || adjudication.value) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {adjudication.amount && <div className="Resource-Left">Amount</div>}
                {adjudication.value && <div className="Resource-Right">Value</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {adjudication.amount && <div className="Res-Title Resource-Left">{Money(adjudication.amount)}</div>}
                {adjudication.value && <div className="Res-Title Resource-Right">{adjudication.value}</div>}
            </div>
        </div>}
    </div>
}

export function Adjudications(adjudications) {
    return adjudications.map((adj, adjidx) => {
        return <div key={`adj-${adjidx}`}>{Adjudication(adj)}</div>
    })
}

export function Item(item) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Service/Product</div>
        </div>
        {(item.sequence || item.productOrService) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.sequence && <div className="Resource-Left">Sequence</div>}
                {item.productOrService && <div className="Resource-Right">Product/Service</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.sequence && <div className="Res-Title Resource-Left">{item.sequence}</div>}
                {item.productOrService && <div className="Res-Title Resource-Right">{CodeableConcept(item.productOrService)}</div>}
            </div>
        </div>}
        {(item.careTeamSequence || item.diagnosisSequence) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.careTeamSequence && <div className="Resource-Left">Care Team Sequence</div>}
                {item.diagnosisSequence && <div className="Resource-Right">Diagnosis Sequence</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.careTeamSequence && <div className="Res-Title Resource-Left">{Integers(item.careTeamSequence)}</div>}
                {item.diagnosisSequence && <div className="Res-Title Resource-Right">{Integers(item.diagnosisSequence)}</div>}
            </div>
        </div>}
        {(item.procedureSequence || item.informationSequence) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.procedureSequence && <div className="Resource-Left">Procedure Sequence</div>}
                {item.informationSequence && <div className="Resource-Right">Information Sequence</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.procedureSequence && <div className="Res-Title Resource-Left">{Integers(item.procedureSequence)}</div>}
                {item.informationSequence && <div className="Res-Title Resource-Right">{Integers(item.informationSequence)}</div>}
            </div>
        </div>}
        {(item.revenue || item.category) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.revenue && <div className="Resource-Left">Revenue/Cost Center</div>}
                {item.category && <div className="Resource-Right">Benefit Classification</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.revenue && <div className="Res-Title Resource-Left">{CodeableConcept(item.revenue)}</div>}
                {item.category && <div className="Res-Title Resource-Right">{CodeableConcept(item.category)}</div>}
            </div>
        </div>}
        {(item.modifier || item.programCode) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.modifier && <div className="Resource-Left">Billing Modifier</div>}
                {item.programCode && <div className="Resource-Right">Program</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.modifier && <div className="Res-Title Resource-Left">{CodeableConcepts(item.modifier)}</div>}
                {item.programCode && <div className="Res-Title Resource-Right">{CodeableConcepts(item.programCode)}</div>}
            </div>
        </div>}
        {(item.serviceDate || item.servicePeriod || item.locationCodeableConcept || item.locationReference) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {(item.serviceDate || item.servicePeriod) && <div className="Resource-Left">Billing Modifier</div>}
                {(item.locationCodeableConcept || item.locationReference) && <div className="Resource-Right">Program</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.serviceDate && <div className="Res-Title Resource-Left">{Choice('Date', item.serviceDate)}</div>}
                {item.servicePeriod && <div className="Res-Title Resource-Left">{Period(item.servicePeriod)}</div>}
                {item.locationCodeableConcept && <div className="Res-Title Resource-Right">{CodeableConcept(item.locationCodeableConcept)}</div>}
                {item.locationReference && <div className="Res-Title Resource-Right">{Reference(item.locationReference)}</div>}
            </div>
        </div>}
        {item.locationAddress && Address(item.locationAddress)}
        {(item.quantity || item.unitPrice) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.quantity && <div className="Resource-Left">Quantity</div>}
                {item.unitPrice && <div className="Resource-Right">Unit Price</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.quantity && <div className="Res-Title Resource-Left">{Quantity(item.quantity)}</div>}
                {item.unitPrice && <div className="Res-Title Resource-Right">{Money(item.unitPrice)}</div>}
            </div>
        </div>}
        {(item.factor || item.net) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.factor && <div className="Resource-Left">Scale Factor</div>}
                {item.net && <div className="Resource-Right">Total</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.factor && <div className="Res-Title Resource-Left">{item.factor}</div>}
                {item.net && <div className="Res-Title Resource-Right">{Money(item.net)}</div>}
            </div>
        </div>}
        {(item.bodySite || item.subSite) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.bodySite && <div className="Resource-Left">Body Site</div>}
                {item.subSite && <div className="Resource-Right">Subsite</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.bodySite && <div className="Res-Title Resource-Left">{CodeableConcept(item.bodySite)}</div>}
                {item.subSite && <div className="Res-Title Resource-Right">{CodeableConcepts(item.subSite)}</div>}
            </div>
        </div>}
        {(item.udi || item.encounter) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.udi && <div className="Resource-Left">Device</div>}
                {item.encounter && <div className="Resource-Right">Encounter</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.udi && <div className="Res-Title Resource-Left">{References(item.udi)}</div>}
                {item.encounter && <div className="Res-Title Resource-Right">{References(item.encounter)}</div>}
            </div>
        </div>}
        {item.noteNumber && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Note Number</div>
                <div className="Res-Title Resource-Left">{Integers(item.noteNumber)}</div>
            </div>
        </div>}
        {item.adjudication && Adjudications(item.adjudication)}
        {item.detail && ItemDetails(item.detail)}
    </div>
}

export function Items(items) {
    return items.sort((a, b) => {
        let x = a.sequence
        let y = b.sequence
        if (x < y) return -1
        if (x > y) return 1
        return 0
    }).map((item, itemidx) => {
        return <div key={`item-${itemidx}`}>{Item(item)}</div>
    })
}

export function ItemDetail(detail) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Detail</div>
        </div>
        {(detail.sequence || detail.revenue) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.sequence && <div className="Resource-Left">Sequence</div>}
                {detail.revenue && <div className="Resource-Right">Revenue/Cost Center</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.sequence && <div className="Res-Title Resource-Left">{detail.sequence}</div>}
                {detail.revenue && <div className="Res-Title Resource-Right">{CodeableConcept(detail.revenue)}</div>}
            </div>
        </div>}
        {(detail.category || detail.productOrService) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.category && <div className="Resource-Left">Benefit</div>}
                {detail.productOrService && <div className="Resource-Right">Product/Service</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.category && <div className="Res-Title Resource-Left">{CodeableConcept(detail.category)}</div>}
                {detail.productOrService && <div className="Res-Title Resource-Right">{CodeableConcept(detail.productOrService)}</div>}
            </div>
        </div>}
        {(detail.modifier || detail.programCode) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.modifier && <div className="Resource-Left">Billing Modifier</div>}
                {detail.programCode && <div className="Resource-Right">Program</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.modifier && <div className="Res-Title Resource-Left">{CodeableConcepts(detail.modifier)}</div>}
                {detail.programCode && <div className="Res-Title Resource-Right">{CodeableConcepts(detail.programCode)}</div>}
            </div>
        </div>}
        {(detail.quantity || detail.unitPrice) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.quantity && <div className="Resource-Left">Quantity</div>}
                {detail.unitPrice && <div className="Resource-Right">Unit Price</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.quantity && <div className="Res-Title Resource-Left">{Quantity(detail.quantity)}</div>}
                {detail.unitPrice && <div className="Res-Title Resource-Right">{Money(detail.unitPrice)}</div>}
            </div>
        </div>}
        {(detail.factor || detail.net) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.factor && <div className="Resource-Left">Scale Factor</div>}
                {detail.net && <div className="Resource-Right">Total</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.factor && <div className="Res-Title Resource-Left">{detail.factor}</div>}
                {detail.net && <div className="Res-Title Resource-Right">{Money(detail.net)}</div>}
            </div>
        </div>}
        {(detail.udi || detail.noteNumber) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.udi && <div className="Resource-Left">Device</div>}
                {detail.noteNumber && <div className="Resource-Right">Note Number</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.udi && <div className="Res-Title Resource-Left">{References(detail.udi)}</div>}
                {detail.noteNumber && <div className="Res-Title Resource-Right">{Integers(detail.noteNumber)}</div>}
            </div>
        </div>}
        {detail.adjudication && <div className="Res-Row"><pre>{JSON.stringify(detail.adjudication, undefined, 2)}</pre></div>}
        {detail.subDetail && ItemSubDetails(detail.adjudication)}
    </div>
}

export function ItemDetails(details) {
    return details.sort((a, b) => {
        let x = a.sequence
        let y = b.sequence
        if (x < y) return -1
        if (x > y) return 1
        return 0
    }).map((detail, detailidx) => {
        return <div key={`item-${detailidx}`}>{ItemDetail(detail)}</div>
    })
}

export function ItemSubDetail(detail) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Additional Items</div>
        </div>
        {(detail.sequence || detail.revenue) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.sequence && <div className="Resource-Left">Sequence</div>}
                {detail.revenue && <div className="Resource-Right">Revenue/Cost Center</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.sequence && <div className="Res-Title Resource-Left">{detail.sequence}</div>}
                {detail.revenue && <div className="Res-Title Resource-Right">{CodeableConcept(detail.revenue)}</div>}
            </div>
        </div>}
        {(detail.category || detail.productOrService) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.category && <div className="Resource-Left">Benefit</div>}
                {detail.productOrService && <div className="Resource-Right">Product/Service</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.category && <div className="Res-Title Resource-Left">{CodeableConcept(detail.category)}</div>}
                {detail.productOrService && <div className="Res-Title Resource-Right">{CodeableConcept(detail.productOrService)}</div>}
            </div>
        </div>}
        {(detail.modifier || detail.programCode) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.modifier && <div className="Resource-Left">Billing Modifier</div>}
                {detail.programCode && <div className="Resource-Right">Program</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.modifier && <div className="Res-Title Resource-Left">{CodeableConcepts(detail.modifier)}</div>}
                {detail.programCode && <div className="Res-Title Resource-Right">{CodeableConcepts(detail.programCode)}</div>}
            </div>
        </div>}
        {(detail.quantity || detail.unitPrice) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.quantity && <div className="Resource-Left">Quantity</div>}
                {detail.unitPrice && <div className="Resource-Right">Unit Price</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.quantity && <div className="Res-Title Resource-Left">{Quantity(detail.quantity)}</div>}
                {detail.unitPrice && <div className="Res-Title Resource-Right">{Money(detail.unitPrice)}</div>}
            </div>
        </div>}
        {(detail.factor || detail.net) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.factor && <div className="Resource-Left">Scale Factor</div>}
                {detail.net && <div className="Resource-Right">Total</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.factor && <div className="Res-Title Resource-Left">{detail.factor}</div>}
                {detail.net && <div className="Res-Title Resource-Right">{Money(detail.net)}</div>}
            </div>
        </div>}
        {(detail.udi || detail.noteNumber) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.udi && <div className="Resource-Left">Device</div>}
                {detail.noteNumber && <div className="Resource-Right">Note Number</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.udi && <div className="Res-Title Resource-Left">{References(detail.udi)}</div>}
                {detail.noteNumber && <div className="Res-Title Resource-Right">{Integers(detail.noteNumber)}</div>}
            </div>
        </div>}
        {detail.adjudication && <div className="Res-Row"><pre>{JSON.stringify(detail.adjudication, undefined, 2)}</pre></div>}
    </div>
}

export function ItemSubDetails(details) {
    return details.sort((a, b) => {
        let x = a.sequence
        let y = b.sequence
        if (x < y) return -1
        if (x > y) return 1
        return 0
    }).map((detail, subdetailidx) => {
        return <div key={`item-${subdetailidx}`}>{ItemSubDetail(detail)}</div>
    })
}


export function AddItem(item) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Service/Product</div>
        </div>
        {(item.itemSequence || item.detailSequence) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.itemSequence && <div className="Resource-Left">Item Sequence</div>}
                {item.detailSequence && <div className="Resource-Right">Product/Service</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.itemSequence && <div className="Res-Title Resource-Left">{Integers(item.itemSequence)}</div>}
                {item.detailSequence && <div className="Res-Title Resource-Right">{Integers(item.detailSequence)}</div>}
            </div>
        </div>}
        {(item.subDetailSequence || item.provider) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.subDetailSequence && <div className="Resource-Left">Item Subdetail Sequence</div>}
                {item.provider && <div className="Resource-Right">Provider</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.subDetailSequence && <div className="Res-Title Resource-Left">{Integers(item.subDetailSequence)}</div>}
                {item.provider && <div className="Res-Title Resource-Right">{Integers(item.provider)}</div>}
            </div>
        </div>}
        {(item.modifier || item.programCode) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.modifier && <div className="Resource-Left">Billing Modifier</div>}
                {item.programCode && <div className="Resource-Right">Program</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.modifier && <div className="Res-Title Resource-Left">{CodeableConcepts(item.modifier)}</div>}
                {item.programCode && <div className="Res-Title Resource-Right">{CodeableConcepts(item.programCode)}</div>}
            </div>
        </div>}
        {(item.serviceDate || item.servicePeriod || item.locationCodeableConcept || item.locationReference) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {(item.serviceDate || item.servicePeriod) && <div className="Resource-Left">Billing Modifier</div>}
                {(item.locationCodeableConcept || item.locationReference) && <div className="Resource-Right">Program</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.serviceDate && <div className="Res-Title Resource-Left">{Choice('Date', item.serviceDate)}</div>}
                {item.servicePeriod && <div className="Res-Title Resource-Left">{Period(item.servicePeriod)}</div>}
                {item.locationCodeableConcept && <div className="Res-Title Resource-Right">{CodeableConcept(item.locationCodeableConcept)}</div>}
                {item.locationReference && <div className="Res-Title Resource-Right">{Reference(item.locationReference)}</div>}
            </div>
        </div>}
        {item.locationAddress && Address(item.locationAddress)}
        {(item.quantity || item.unitPrice) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.quantity && <div className="Resource-Left">Quantity</div>}
                {item.unitPrice && <div className="Resource-Right">Unit Price</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.quantity && <div className="Res-Title Resource-Left">{Quantity(item.quantity)}</div>}
                {item.unitPrice && <div className="Res-Title Resource-Right">{Money(item.unitPrice)}</div>}
            </div>
        </div>}
        {(item.factor || item.net) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.factor && <div className="Resource-Left">Scale Factor</div>}
                {item.net && <div className="Resource-Right">Total</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.factor && <div className="Res-Title Resource-Left">{item.factor}</div>}
                {item.net && <div className="Res-Title Resource-Right">{Money(item.net)}</div>}
            </div>
        </div>}
        {(item.bodySite || item.subSite) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {item.bodySite && <div className="Resource-Left">Body Site</div>}
                {item.subSite && <div className="Resource-Right">Subsite</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {item.bodySite && <div className="Res-Title Resource-Left">{CodeableConcept(item.bodySite)}</div>}
                {item.subSite && <div className="Res-Title Resource-Right">{CodeableConcepts(item.subSite)}</div>}
            </div>
        </div>}
        {item.noteNumber && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Note Number</div>
                <div className="Res-Title Resource-Left">{Integers(item.noteNumber)}</div>
            </div>
        </div>}
        {item.adjudication && <div className="Res-Row"><pre>{JSON.stringify(item.adjudication, undefined, 2)}</pre></div>}
        {item.detail && AddItemDetails(item.detail)}
    </div>
}

export function AddItems(items) {
    return items.sort((a, b) => {
        let x = a.sequence
        let y = b.sequence
        if (x < y) return -1
        if (x > y) return 1
        return 0
    }).map((item, additemidx) => {
        return <div key={`additem-${additemidx}`}>{AddItem(item)}</div>
    })
}

export function AddItemDetail(detail) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Addtional Item Detail</div>
        </div>
        {(detail.modifier || detail.productOrService) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.modifier && <div className="Resource-Left">Billing Modifier</div>}
                {detail.productOrService && <div className="Resource-Right">Product/Service</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.modifier && <div className="Res-Title Resource-Left">{CodeableConcepts(detail.modifier)}</div>}
                {detail.productOrService && <div className="Res-Title Resource-Right">{CodeableConcept(detail.productOrService)}</div>}
            </div>
        </div>}
        {(detail.quantity || detail.unitPrice) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.quantity && <div className="Resource-Left">Quantity</div>}
                {detail.unitPrice && <div className="Resource-Right">Unit Price</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.quantity && <div className="Res-Title Resource-Left">{Quantity(detail.quantity)}</div>}
                {detail.unitPrice && <div className="Res-Title Resource-Right">{Money(detail.unitPrice)}</div>}
            </div>
        </div>}
        {(detail.factor || detail.net) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.factor && <div className="Resource-Left">Scale Factor</div>}
                {detail.net && <div className="Resource-Right">Total</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.factor && <div className="Res-Title Resource-Left">{detail.factor}</div>}
                {detail.net && <div className="Res-Title Resource-Right">{Money(detail.net)}</div>}
            </div>
        </div>}
        {detail.noteNumber && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Note Number</div>
            </div>
            <div className="Res-Row">
                <div className="Res-Title Resource-Left">{Integers(detail.noteNumber)}</div>
            </div>
        </div>}
        {detail.adjudication && <div className="Res-Row"><pre>{JSON.stringify(detail.adjudication, undefined, 2)}</pre></div>}
    </div>
}

export function AddItemDetails(details) {
    return details.sort((a, b) => {
        let x = a.sequence
        let y = b.sequence
        if (x < y) return -1
        if (x > y) return 1
        return 0
    }).map((detail, adddetailidx) => {
        return <div key={`additemdet-${adddetailidx}`}>{AddItemDetail(detail)}</div>
    })
}

export function AddItemSubDetail(detail) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Additional Item Subdetail</div>
        </div>
        {(detail.modifier || detail.productOrService) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.productOrService && <div className="Res-Title Resource-Left">Product/Service</div>}
                {detail.modifier && <div className="Resource-Right">Billing Modifier</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.productOrService && <div className="Res-Title Resource-Left">{CodeableConcept(detail.productOrService)}</div>}
                {detail.modifier && <div className="Res-Title Resource-Right">{CodeableConcepts(detail.modifier)}</div>}
            </div>
        </div>}
        {(detail.quantity || detail.unitPrice) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.quantity && <div className="Resource-Left">Quantity</div>}
                {detail.unitPrice && <div className="Resource-Right">Unit Price</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.quantity && <div className="Res-Title Resource-Left">{Quantity(detail.quantity)}</div>}
                {detail.unitPrice && <div className="Res-Title Resource-Right">{Money(detail.unitPrice)}</div>}
            </div>
        </div>}
        {(detail.factor || detail.net) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {detail.factor && <div className="Resource-Left">Scale Factor</div>}
                {detail.net && <div className="Resource-Right">Total</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {detail.factor && <div className="Res-Title Resource-Left">{detail.factor}</div>}
                {detail.net && <div className="Res-Title Resource-Right">{Money(detail.net)}</div>}
            </div>
        </div>}
        {detail.noteNumber && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Note Number</div>
            </div>
            <div className="Res-Row">
                <div className="Res-Title Resource-Left">{Integers(detail.noteNumber)}</div>
            </div>
        </div>}
        {detail.adjudication && <div className="Res-Row"><pre>{JSON.stringify(detail.adjudication, undefined, 2)}</pre></div>}
    </div>
}

export function AddItemSubDetails(details) {
    return details.sort((a, b) => {
        let x = a.sequence
        let y = b.sequence
        if (x < y) return -1
        if (x > y) return 1
        return 0
    }).map((detail, addsubdetailidx) => {
        return <div key={`additemsubdet-${addsubdetailidx}`}>{AddItemSubDetail(detail)}</div>
    })
}

export function Total(total) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Total</div>
        </div>
        {(total.category || total.amount) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {total.category && <div className="Resource-Left">Type</div>}
                {total.amount && <div className="Resource-Right">Amount</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {total.category && <div className="Res-Title Resource-Left">{CodeableConcept(total.category)}</div>}
                {total.amount && <div className="Res-Title Resource-Right">{Money(total.amount)}</div>}
            </div>
        </div>}
    </div>
}

export function Totals(totals) {
    return totals.map((tot, totidx) => {
        return <div key={`tot-${totidx}`}>{Total(tot)}</div>
    })
}

export function Payment(payment) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Payment</div>
        </div>
        {(payment.type || payment.adjustment) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {payment.type && <div className="Resource-Left">Type</div>}
                {payment.adjustment && <div className="Resource-Right">Adjustment</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {payment.type && <div className="Res-Title Resource-Left">{CodeableConcept(payment.type)}</div>}
                {payment.adjustment && <div className="Res-Title Resource-Right">{Money(payment.adjustment)}</div>}
            </div>
        </div>}
        {(payment.date || payment.adjustmentReason) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {payment.date && <div className="Resource-Left">Date</div>}
                {payment.adjustmentReason && <div className="Resource-Right">Adjustment Reason</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {payment.date && <div className="Res-Title Resource-Left">{Choice('Date', payment.date)}</div>}
                {payment.adjustmentReason && <div className="Res-Title Resource-Right">{CodeableConcept(payment.adjustmentReason)}</div>}
            </div>
        </div>}
        {payment.amount && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Right">Amount</div>
            </div>
            <div className="Res-Row">
                <div className="Res-Title Resource-Right">{Money(payment.amount)}</div>
            </div>
        </div>}
        {payment.identifier && Identifier(payment.identifier)}
    </div>
}

export function ProcessNote(processNote) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Process Note</div>
        </div>
        {(processNote.number || processNote.type) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {processNote.number && <div className="Resource-Left">Number</div>}
                {processNote.type && <div className="Resource-Right">Type</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {processNote.number && <div className="Res-Title Resource-Left">{processNote.number}</div>}
                {processNote.type && <div className="Res-Title Resource-Right">{processNote.type}</div>}
            </div>
        </div>}
        {processNote.text && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Note</div>
            </div>
            <div className="Res-Row">
                <div className="Res-Title Resource-Left">{processNote.text}</div>
            </div>
        </div>}
    </div>
}

export function ProcessNotes(processNotes) {
    return processNotes.map((pn, pnidx) => {
        return <div key={`pn-${pnidx}`}>{ProcessNote(pn)}</div>
    })
}

export function BenefitBalance(benefitBalance) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Benefit Balance</div>
        </div>
        {(benefitBalance.name || benefitBalance.category) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {benefitBalance.name && <div className="Resource-Left">Benefit</div>}
                {benefitBalance.category && <div className="Resource-Right">Class</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {benefitBalance.name && <div className="Res-Title Resource-Left">{benefitBalance.name}</div>}
                {benefitBalance.category && <div className="Res-Title Resource-Right">{CodeableConcept(benefitBalance.category)}</div>}
            </div>
        </div>}
        {(benefitBalance.network || benefitBalance.excluded) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {benefitBalance.network && <div className="Resource-Left">Network</div>}
                {benefitBalance.excluded && <div className="Resource-Right">Excluded</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {benefitBalance.network && <div className="Res-Title Resource-Left">{CodeableConcept(benefitBalance.network)}</div>}
                {benefitBalance.excluded && <div className="Res-Title Resource-Right">{Choice('Boolean', benefitBalance.excluded)}</div>}
            </div>
        </div>}
        {benefitBalance.description && <div>
            <div className="Res-Row Res-Detail">
                <div className="Resource-Left">Description</div>
            </div>
            <div className="Res-Row">
                <div className="Res-Title Resource-Left">{benefitBalance.description}</div>
            </div>
        </div>}
        {(benefitBalance.unit || benefitBalance.term) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {benefitBalance.unit && <div className="Resource-Left">Individual/Family</div>}
                {benefitBalance.term && <div className="Resource-Right">Term</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {benefitBalance.unit && <div className="Res-Title Resource-Left">{CodeableConcept(benefitBalance.unit)}</div>}
                {benefitBalance.term && <div className="Res-Title Resource-Right">{CodeableConcept(benefitBalance.term)}</div>}
            </div>
        </div>}
        {benefitBalance.financial && Financials(benefitBalance.financial)}
    </div>
}

export function BenefitBalances(benefitBalances) {
    return benefitBalances.map((bb, bbidx) => {
        return <div key={`bb-${bbidx}`}>{BenefitBalance(bb)}</div>
    })
}

export function Financial(financial) {
    return <div>
        <div className="Res-Row">
            <div className="Res-Title" style={{ width: '100%', textAlign: 'center' }}>Benefit Summary</div>
        </div>
        {(financial.category || financial.amount) && <div>
            <div className="Res-Row Res-Detail Res-Flex-Spread">
                {financial.category && <div className="Resource-Left">Type</div>}
                {financial.amount && <div className="Resource-Right">Amount</div>}
            </div>
            <div className="Res-Row Res-Flex-Spread">
                {financial.category && <div className="Res-Title Resource-Left">{CodeableConcept(financial.category)}</div>}
                {financial.amount && <div className="Res-Title Resource-Right">{Money(financial.amount)}</div>}
            </div>
        </div>}
    </div>
}

export function Financials(financials) {
    return financials.map((f, finidx) => {
        return <div key={`fin-${finidx}`}>{BenefitBalance(f)}</div>
    })
}

export function Result(result) {
    return result.map((r, ridx) => {
        return <div key={`result-${ridx}`}>{r.display}</div>
    })
}